// 相机控制注册表：SceneCanvas 内部注册实现，SceneToolbar 触发调用
// 避免工具栏（Canvas 外部）无法使用 useThree 的问题

type FocusFn = () => void;
type ViewFn = (view: string) => void;
type AutoFitFn = () => void;
type ApplyCameraFn = (camera: CameraSnapshot) => void;

export interface CameraSnapshot {
  position: [number, number, number];
  target: [number, number, number];
}

// 2026-10-15（P0-④ 鸟瞰相机）：球坐标视角快照（alpha=方位角 beta=极角 radius=距离）
export interface CameraViewSnapshot {
  alpha: number;
  beta: number;
  radius: number;
  target: [number, number, number];
}

type GetCameraFn = () => CameraSnapshot | null;
/** 请求重绘（displayOnly demand 模式：状态变化后主动 invalidate） */
type RequestRenderFn = () => void;
/** 2026-08-26｜设备联动定位：相机飞到指定位置并看向目标（air8000w 点击 → 高空俯视水池/工厂全景） */
type FlyToFn = (position: [number, number, number], target: [number, number, number]) => void;

export const cameraControlsRegistry: {
  focusSelected: FocusFn | null;
  resetCamera: FocusFn | null;
  setView: ViewFn | null;
  /** 立即执行一次自动适配（显式触发，不等首次加载） */
  autoFit: AutoFitFn | null;
  /** 读取当前相机位置/目标（用于"保存当前视角"策略） */
  getCamera: GetCameraFn | null;
  /** 应用保存的相机状态 */
  applySavedCamera: ApplyCameraFn | null;
  /** 2026-10-15（P0-④）：读取当前视角（球坐标快照；鸟瞰相机用） */
  getCameraView: (() => CameraViewSnapshot | null) | null;
  /** 2026-10-15（P0-④）：应用视角快照（球坐标；鸟瞰相机预设/初始视角用） */
  applyCameraView: ((view: CameraViewSnapshot) => void) | null;
  /** 启用/禁用 OrbitControls（相机实体 gizmo 拖拽时禁用，防互相干扰） */
  setOrbitControlsEnabled: ((enabled: boolean) => void) | null;
  /** 请求重绘（demand 模式） */
  requestRender: RequestRenderFn | null;
  /** 设备联动定位（飞到指定位置+目标） */
  flyToPosition: FlyToFn | null;
  /** 2026-09-14：模型加载完成通知——大模型（数十 MB、解析数分钟）加载完成时补一次自动适配（auto 策略） */
  onModelLoaded: (() => void) | null;
  /** 2026-09-14：导入模型后强制适配请求（无视相机策略，给新导入模型一个能看到整体的视角） */
  requestImportFit: (() => void) | null;
} = {
  focusSelected: null,
  resetCamera: null,
  setView: null,
  autoFit: null,
  getCamera: null,
  applySavedCamera: null,
  getCameraView: null,
  applyCameraView: null,
  setOrbitControlsEnabled: null,
  requestRender: null,
  flyToPosition: null,
  onModelLoaded: null,
  requestImportFit: null,
};

// 调试/测试桥（E2E）：相机控制注册表（同 window.__popupStore 先例）——用于确定性设置编辑器相机位姿
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).__cameraRegistry = cameraControlsRegistry;
}